/* 
CASOS DE VALIDACIÓN PARA EDICIÓN DE USUARIO:

✅ CASOS EXITOSOS:
1. Email y teléfono del usuario actual → Actualizar
2. Solo email del usuario actual → Actualizar  
3. Solo teléfono del usuario actual → Actualizar
4. Email y teléfono nuevos → Actualizar

❌ CASOS DE ERROR:
5. Email de otro usuario → Rechazar
6. Teléfono de otro usuario → Rechazar
7. Email y teléfono de diferentes usuarios → Rechazar
8. Cualquier otro caso → Rechazar
*/

/*
CASOS DE VALIDACIÓN PARA CREAR NUEVO USUARIO:

✅ CASOS EXITOSOS:
1. Email y teléfono nuevos (no existen) → Crear usuario

❌ CASOS DE ERROR:
2. Email ya existe → Rechazar "Email ya registrado"
3. Teléfono ya existe → Rechazar "Teléfono ya registrado" 
4. Ambos ya existen → Rechazar "Email y teléfono ya registrados"
5. Cualquier otro caso → Rechazar
*/

/**
 * Maneja la creación o actualización de un cliente según el email y teléfono recibidos.
 *
 * - Verifica si el email y teléfono existen en la base de datos.
 * - Combina direcciones nuevas con las existentes, evitando duplicados.
 * - Si ambos existen y son del mismo cliente, actualiza sus datos.
 * - Si solo existe uno, usa ese cliente para actualizar o crear nuevo si es un email auxiliar.
 * - Si ambos existen pero son diferentes, muestra error a menos que el email sea auxiliar.
 * - Evita que empleados del Contact Center sean tratados como clientes.
 * - Guarda los datos procesados en localStorage para uso del Call Center.
 * - Redirige al usuario o muestra errores según corresponda.
 */

class GestorClienteShopify {
  // Actualiazcion solamente (RAZON SOCIAL Y NIT)
  static async editarNITyRazonSocial(infoUsuario) {
    const graphQLQuery = `
      mutation UpdateCustomerMetafields($input: CustomerInput!) {
        customerUpdate(input: $input) {
          customer {
            id
            metafield(namespace: "informacion", key: "extra") {
              id
              namespace
              key
              value
            }
          }
          userErrors {
            field
            message
          }
        }
      }
    `;

    var metafields = {
      nit: infoUsuario.nit,
      razon_social: infoUsuario.razon_social,
      fecha: infoUsuario.fecha_nacimiento,
      permisosHutCoins: infoUsuario.permisosHutCoins,
      ci: infoUsuario.ci,
      direcciones: infoUsuario.direcciones,
    };

    const variables = {
      input: {
        id: infoUsuario.id,
        metafields: [
          {
            namespace: "informacion",
            key: "extra",
            type: "json_string",
            value: JSON.stringify(metafields),
          },
        ],
      },
    };

    try {
      const respuesta = await fetch(window.urlConsulta, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          query: graphQLQuery,
          variables: variables,
        }),
      });

      const datos = await respuesta.json();
      console.log("Respuesta de la API:", datos);

      if (datos.data?.customerUpdate?.userErrors?.length > 0) {
        return {
          exito: false,
          errores: datos.data.customerUpdate.userErrors,
        };
      }

      return {
        exito: true,
        metafield: datos.data.customerUpdate.customer.metafield,
      };
    } catch (error) {
      console.error("Error al actualizar razon social y NIT:", error);
      return {
        exito: false,
        error: error.message,
      };
    }
  }

  // Actualizar datos del cliente
  static async actualizarDatosUsuario(id, thisContexto) {
    const datosUsuario = JSON.parse(
      localStorage.getItem("ph-datos-usuario") || "{}"
    );

    const graphQLQuery = `
    mutation UpdateCustomer($input: CustomerInput!) {
      customerUpdate(input: $input) {
        customer {
          id
          firstName
          lastName
          email
          phone
          metafield(namespace: "informacion", key: "extra") {
            id
            key
            namespace
            value
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  `;

    const informacionExtra = JSON.stringify({
      nit:
        thisContexto.inputNitoCit.value == ""
          ? datosUsuario.nit
          : thisContexto.inputNitoCit.value,
      razon_social:
        thisContexto.inputRazonSocial.value == ""
          ? datosUsuario.razon_social
          : thisContexto.inputRazonSocial.value,
      fecha:
        thisContexto.inputFechaNacimiento.value == ""
          ? datosUsuario.fecha_nacimiento
          : thisContexto.inputFechaNacimiento.value,
      permisosHutCoins: thisContexto.btnHutCoins.classList.contains(
        "seleccionado"
      )
        ? true
        : false,
      ci:
        thisContexto.inputCIContacto.value == ""
          ? datosUsuario.ci
          : thisContexto.inputCIContacto.value,
      direcciones: thisContexto.listaDireccionesGuardadas,
    });

    const variables = {
      input: {
        id: `gid://shopify/Customer/${id}`,
        firstName:
          thisContexto.inputNombreContacto.value == ""
            ? datosUsuario.nombre
            : thisContexto.inputNombreContacto.value,
        lastName:
          thisContexto.inputApellidoContacto.value == ""
            ? datosUsuario.apellido
            : thisContexto.inputApellidoContacto.value,
        email:
          thisContexto.inputCorreoElectronico.value == ""
            ? datosUsuario.email
            : thisContexto.inputCorreoElectronico.value,
        phone: `+591${thisContexto.inputCelularContacto.value == ""
          ? datosUsuario.celular
          : thisContexto.inputCelularContacto.value
          }`,
        metafields: [
          {
            namespace: "informacion",
            key: "extra",
            type: "json_string",
            value: informacionExtra,
          },
        ],
      },
    };

    try {
      const respuesta = await fetch(window.urlConsulta, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          query: graphQLQuery,
          variables: variables,
        }),
      });

      const datos = await respuesta.json();
      console.log("Respuesta de la API:", datos);

      // Verificar si hay errores en la respuesta de Shopify
      if (
        datos.data?.customerUpdate?.userErrors &&
        datos.data.customerUpdate.userErrors.length > 0
      ) {
        // Examinar el tipo específico de error
        const userErrors = datos.data.customerUpdate.userErrors;

        // Buscar específicamente error de email duplicado
        const emailError = userErrors.find(
          (error) =>
            error.field &&
            error.field.includes("email") &&
            error.message &&
            error.message.includes("already exists")
        );

        if (emailError) {
          return {
            error:
              "El correo electrónico ya está registrado. Por favor, intenta con otro correo.",
          };
        }

        // Para otros tipos de errores
        return {
          error: "Revisa tus datos, por favor.",
        };
      }

      // Verificar si el customer es null (como en tu ejemplo)
      if (datos.data?.customerUpdate?.customer === null) {
        return {
          error: "No se pudo actualizar la información. Verifica tus datos.",
        };
      }

      // Obtener el cliente actualizado
      const customer = datos.data?.customerUpdate?.customer;
      if (!customer) {
        return {
          error: "No se pudo obtener la información actualizada del cliente.",
        };
      }

      // Procesar los metafields para extraer la información extra
      let metafieldData = {};
      if (customer?.metafield?.value) {
        try {
          metafieldData = JSON.parse(customer.metafield.value);
        } catch (e) {
          console.error("Error al parsear metafield:", e);
        }
      }

      // Devolver el objeto con el formato solicitado
      return {
        id: customer.id,
        nombre: customer.firstName,
        celular: customer.phone?.replace(/^\+591/, "") || "",
        apellido: customer.lastName,
        email: customer.email,
        ci: metafieldData.ci || "",
        direcciones: metafieldData.direcciones || [],
        razon_social: metafieldData.razon_social || "",
        nit: metafieldData.nit || "",
        fecha_nacimiento: metafieldData.fecha || "",
        permisosHutCoins: metafieldData.permisosHutCoins || false,
      };
    } catch (error) {
      console.error("Error al actualizar datos de usuario:", error);
      return {
        error:
          "Ha ocurrido un error al actualizar los datos. Inténtalo de nuevo.",
      };
    }
  }

  static async actualizarDatosUsuarioNew(datosUsuario) {
    const usuarioLocalStorage = JSON.parse(
      localStorage.getItem("ph-datos-usuario") || "{}"
    );

    const graphQLQuery = `
    mutation UpdateCustomer($input: CustomerInput!) {
      customerUpdate(input: $input) {
        customer {
          id
          firstName
          lastName
          email
          phone
          metafield(namespace: "informacion", key: "extra") {
            id
            key
            namespace
            value
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  `;

    // Función helper para validar si un valor está vacío, null o undefined
    const esVacio = (valor) => {
      return valor === "" || valor === null || valor === undefined;
    };

    const informacionExtra = JSON.stringify({
      ci: esVacio(datosUsuario.ci)
        ? usuarioLocalStorage.ci || ""
        : datosUsuario.ci,
      nit: esVacio(datosUsuario.nit)
        ? usuarioLocalStorage.nit || ""
        : datosUsuario.nit,
      razon_social: esVacio(datosUsuario.razon_social)
        ? usuarioLocalStorage.razon_social || ""
        : datosUsuario.razon_social,
      fecha: esVacio(datosUsuario.fecha_nacimiento)
        ? usuarioLocalStorage.fecha_nacimiento || ""
        : datosUsuario.fecha_nacimiento,
      permisosHutCoins: esVacio(datosUsuario.permisosHutCoins)
        ? usuarioLocalStorage.permisosHutCoins || false
        : datosUsuario.permisosHutCoins,
      direcciones:
        datosUsuario.direcciones || usuarioLocalStorage.direcciones || [],
    });

    const variables = {
      input: {
        id: datosUsuario.id,
        firstName: esVacio(datosUsuario.nombre)
          ? usuarioLocalStorage.nombre || ""
          : datosUsuario.nombre,
        lastName: esVacio(datosUsuario.apellido)
          ? usuarioLocalStorage.apellido || ""
          : datosUsuario.apellido,
        email: esVacio(datosUsuario.email)
          ? usuarioLocalStorage.email || ""
          : datosUsuario.email,
        phone: `+591${esVacio(datosUsuario.celular)
          ? usuarioLocalStorage.celular || ""
          : datosUsuario.celular
          }`,
        metafields: [
          {
            namespace: "informacion",
            key: "extra",
            type: "json_string",
            value: informacionExtra,
          },
        ],
      },
    };

    try {
      const respuesta = await fetch(window.urlConsulta, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          query: graphQLQuery,
          variables: variables,
        }),
      });

      if (!respuesta.ok) {
        throw new Error(
          `Error de red: ${respuesta.status} ${respuesta.statusText}`
        );
      }

      const datos = await respuesta.json();

      // Verificar si hay errores en la respuesta GraphQL
      if (datos.errors && datos.errors.length > 0) {
        throw new Error(
          `Error GraphQL: ${datos.errors.map((e) => e.message).join(", ")}`
        );
      }

      // Verificar si hay errores en la respuesta de Shopify
      if (
        datos.data?.customerUpdate?.userErrors &&
        datos.data.customerUpdate.userErrors.length > 0
      ) {
        const userErrors = datos.data.customerUpdate.userErrors;
        // Log detallado para desarrollador
        console.error(
          `USER ERRORS actualizarDatosUsuario: ${JSON.stringify(
            userErrors
          )} | ID: ${datosUsuario.id} | Email: ${variables.input.email
          } | Timestamp: ${new Date().toISOString()}`
        );

        // Buscar específicamente error de email duplicado
        const emailError = userErrors.find(
          (error) =>
            error.field &&
            error.field.includes("email") &&
            error.message &&
            error.message.includes("already exists")
        );

        if (emailError) {
          return {
            error:
              "El correo electrónico ya está registrado. Por favor, intenta con otro correo.",
          };
        }

        // Para otros tipos de errores
        return {
          error: "Revisa tus datos, por favor.",
        };
      }

      // Verificar si el customer es null
      if (datos.data?.customerUpdate?.customer === null) {
        console.error(
          `CUSTOMER NULL actualizarDatosUsuario: ID: ${datosUsuario.id
          } | Respuesta: ${JSON.stringify(
            datos
          )} | Timestamp: ${new Date().toISOString()}`
        );
        return {
          error: "No se pudo actualizar la información. Verifica tus datos.",
        };
      }

      // Obtener el cliente actualizado
      const customer = datos.data?.customerUpdate?.customer;
      if (!customer) {
        console.error(
          `NO CUSTOMER actualizarDatosUsuario: ID: ${datosUsuario.id
          } | Respuesta: ${JSON.stringify(
            datos
          )} | Timestamp: ${new Date().toISOString()}`
        );
        return {
          error: "No se pudo obtener la información actualizada del cliente.",
        };
      }

      // Procesar los metafields para extraer la información extra
      let metafieldData = {};
      if (customer?.metafield?.value) {
        try {
          metafieldData = JSON.parse(customer.metafield.value);
        } catch (e) {
          console.error(
            `ERROR METAFIELD actualizarDatosUsuario: ${e.message} | Valor: ${customer.metafield.value
            } | ID: ${customer.id} | Timestamp: ${new Date().toISOString()}`
          );
        }
      }

      // Log de éxito
      console.log(
        `ACTUALIZACIÓN EXITOSA: ID: ${datosUsuario.id} | Email: ${customer.email
        } | Timestamp: ${new Date().toISOString()}`
      );

      // Devolver el objeto con el formato solicitado
      return {
        id: customer.id,
        nombre: customer.firstName || "",
        celular: customer.phone?.replace(/^\+591/, "") || "",
        apellido: customer.lastName || "",
        email: customer.email || "",
        ci: metafieldData.ci || "",
        direcciones: metafieldData.direcciones || [],
        razon_social: metafieldData.razon_social || "",
        nit: metafieldData.nit || "",
        fecha_nacimiento: metafieldData.fecha || "",
        permisosHutCoins: metafieldData.permisosHutCoins || false,
      };
    } catch (error) {
      // Log detallado para el desarrollador en una línea
      console.error(
        `ERROR actualizarDatosUsuario: ${error.message} | ID: ${datosUsuario.id
        } | Email: ${variables.input.email} | Tipo: ${error.constructor.name
        } | Timestamp: ${new Date().toISOString()} | Stack: ${error.stack}`
      );

      // Determinar mensaje amigable para el usuario
      let mensajeUsuario = "";
      if (error.message.includes("Error de red")) {
        mensajeUsuario =
          "No se pudo conectar con el servidor. Por favor, verifica tu conexión a internet e intenta nuevamente.";
      } else if (error.message.includes("fetch")) {
        mensajeUsuario =
          "Problema de conexión. Por favor, intenta nuevamente en unos momentos.";
      } else if (error.message.includes("JSON")) {
        mensajeUsuario =
          "Error al procesar la información. Por favor, contacta al soporte técnico.";
      } else if (error.message.includes("GraphQL")) {
        mensajeUsuario =
          "Error en la actualización de datos. Por favor, verifica la información e intenta nuevamente.";
      } else if (error.message.includes("TypeError")) {
        mensajeUsuario =
          "Error en el formato de datos. Por favor, contacta al soporte técnico.";
      } else if (error.message.includes("localStorage")) {
        mensajeUsuario =
          "Error al acceder a los datos locales. Por favor, recarga la página e intenta nuevamente.";
      } else {
        mensajeUsuario =
          "Ha ocurrido un error inesperado al actualizar los datos. Por favor, intenta nuevamente o contacta al soporte técnico.";
      }

      // Devolver error con mensaje amigable para el usuario
      return {
        error: mensajeUsuario,
      };
    }
  }

  // Verificar nro. de celular del cliente (Si existe o no)
  static async porNroTelefonoUsuarioVerificar(numeroTelefono) {
    const graphQLQuery = `
      query($identifier: CustomerIdentifierInput!) {
        customer: customerByIdentifier(identifier: $identifier) {
          id
          metafield(namespace: "informacion", key: "extra") {
            id
            key
            namespace
            value
          }
        }
      }
    `;

    const variables = {
      identifier: {
        phoneNumber: numeroTelefono,
      },
    };

    try {
      // Usar el servidor intermediario local en lugar de la API directa de Shopify
      const respuesta = await fetch(window.urlConsulta, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          query: graphQLQuery,
          variables: variables,
        }),
      });

      if (!respuesta.ok) {
        throw new Error(
          `Error de red: ${respuesta.status} ${respuesta.statusText}`
        );
      }

      const datos = await respuesta.json();

      // Verificar si hay resultados y extraer solo el número del ID
      if (datos.data?.customer?.id) {
        // Extraer solo el número del ID (después de la última barra)
        const idCompleto = datos.data.customer.id;
        const numeroID = idCompleto.split("/").pop();
        return numeroID;
      } else {
        return undefined;
      }
    } catch (error) {
      console.error("Error al verificar usuario por teléfono:", error);
      return undefined;
    }
  }

  static async porNroTelefonoUsuarioVerificarNew(numeroTelefono) {
    const graphQLQuery = `
    query($identifier: CustomerIdentifierInput!) {
      customer: customerByIdentifier(identifier: $identifier) {
        id
        metafield(namespace: "informacion", key: "extra") {
          id
          key
          namespace
          value
        }
      }
    }
  `;

    const variables = {
      identifier: {
        phoneNumber: numeroTelefono,
      },
    };

    try {
      // Usar el servidor intermediario local en lugar de la API directa de Shopify
      const respuesta = await fetch(window.urlConsulta, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          query: graphQLQuery,
          variables: variables,
        }),
      });

      if (!respuesta.ok) {
        throw new Error(
          `Error de red: ${respuesta.status} ${respuesta.statusText}`
        );
      }

      const datos = await respuesta.json();

      // Verificar si hay errores en la respuesta GraphQL
      if (datos.errors && datos.errors.length > 0) {
        throw new Error(
          `Error GraphQL: ${datos.errors.map((e) => e.message).join(", ")}`
        );
      }

      // Verificar si hay resultados y extraer solo el número del ID
      if (datos.data?.customer?.id) {
        // Extraer solo el número del ID (después de la última barra)
        const idCompleto = datos.data.customer.id;
        const numeroID = idCompleto.split("/").pop();

        console.log(
          `USUARIO ENCONTRADO POR TELÉFONO: Tel: ${numeroTelefono} | ID: ${numeroID} | Timestamp: ${new Date().toISOString()}`
        );

        return numeroID;
      } else {
        console.log(
          `USUARIO NO ENCONTRADO POR TELÉFONO: Tel: ${numeroTelefono} | Respuesta: ${JSON.stringify(
            datos
          )} | Timestamp: ${new Date().toISOString()}`
        );
        return undefined;
      }
    } catch (error) {
      // Log detallado para el desarrollador en una línea
      console.error(
        `ERROR porNroTelefonoUsuarioVerificar: ${error.message
        } | Teléfono: ${numeroTelefono} | Tipo: ${error.constructor.name
        } | Timestamp: ${new Date().toISOString()} | Stack: ${error.stack}`
      );

      // Determinar mensaje amigable para el usuario
      let mensajeUsuario = "";

      if (error.message.includes("Error de red")) {
        mensajeUsuario =
          "No se pudo conectar con el servidor. Por favor, verifica tu conexión a internet e intenta nuevamente.";
      } else if (error.message.includes("fetch")) {
        mensajeUsuario =
          "Problema de conexión. Por favor, intenta nuevamente en unos momentos.";
      } else if (error.message.includes("JSON")) {
        mensajeUsuario =
          "Error al procesar la información del usuario. Por favor, contacta al soporte técnico.";
      } else if (error.message.includes("GraphQL")) {
        mensajeUsuario =
          "Error en la consulta de datos. Por favor, verifica el número de teléfono e intenta nuevamente.";
      } else if (error.message.includes("TypeError")) {
        mensajeUsuario =
          "Error en el formato de datos. Por favor, contacta al soporte técnico.";
      } else {
        mensajeUsuario =
          "Ocurrió un error inesperado al verificar el número de teléfono. Por favor, intenta nuevamente o contacta al soporte técnico.";
      }

      // Lanzar error con mensaje amigable para el usuario
      throw new Error(mensajeUsuario);
    }
  }

  // Solamente debe actualizar las direcciones (cliente)
  static async actualizarMetaFieldDireccionCliente(thisContexto) {
    const datosUsuario = JSON.parse(
      localStorage.getItem("ph-datos-usuario") || "{}"
    );

    const graphQLQuery = `
    mutation UpdateCustomer($input: CustomerInput!) {
      customerUpdate(input: $input) {
        customer {
          id
          firstName
          lastName
          email
          phone
          metafield(namespace: "informacion", key: "extra") {
            id
            key
            namespace
            value
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  `;

    const informacionExtra = JSON.stringify({
      nit: datosUsuario.nit || "",
      razon_social: datosUsuario.razon_social || "",
      fecha: datosUsuario.fecha_nacimiento || "",
      permisosHutCoins: datosUsuario.permisosHutCoins || false,
      ci: datosUsuario.ci || "",
      direcciones: thisContexto.listaDireccionesGuardadas || [],
    });

    const variables = {
      input: {
        id: datosUsuario.id,
        metafields: [
          {
            namespace: "informacion",
            key: "extra",
            type: "json_string",
            value: informacionExtra,
          },
        ],
      },
    };

    try {
      const respuesta = await fetch(window.urlConsulta, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          query: graphQLQuery,
          variables: variables,
        }),
      });

      const datos = await respuesta.json();
      console.log("Respuesta de la API:", datos);

      if (datos.data?.customerUpdate?.userErrors?.length > 0) {
        return {
          exito: false,
          errores: datos.data.customerUpdate.userErrors,
        };
      }

      // Obtener el cliente actualizado
      const customer = datos.data?.customerUpdate?.customer;

      // Procesar los metafields para extraer la información extra
      let metafieldData = {};
      if (customer?.metafield?.value) {
        try {
          metafieldData = JSON.parse(customer.metafield.value);
        } catch (e) {
          console.error("Error al parsear metafield:", e);
        }
      }

      // Devolver el objeto con el formato solicitado
      return {
        id: customer.id,
        nombre: customer.firstName,
        celular: customer.phone?.replace(/^\+591/, "") || "",
        apellido: customer.lastName,
        email: customer.email,
        ci: metafieldData.ci || "",
        direcciones: metafieldData.direcciones || [],
        razon_social: metafieldData.razon_social || "",
        nit: metafieldData.nit || "",
        fecha_nacimiento: metafieldData.fecha || "",
        permisosHutCoins: metafieldData.permisosHutCoins || false,
      };
    } catch (error) {
      console.error("Error al actualizar datos de usuario:", error);
      return {
        exito: false,
        error: error.message,
      };
    }
  }

  // Crear un nuevo cliente en Shopify
  static async crearNuevoClienteShopify(datosCliente) {
    // Convertir los datos adicionales a formato JSON para el metafield
    const metafieldValue = `{
            "nit": "${datosCliente.nit}",
            "razon_social": "${datosCliente.razon_social}",
            "fecha": "${datosCliente.fecha_nacimiento}",
            "permisosHutCoins": "${datosCliente.permisosHutCoins}",
            "ci": "${datosCliente.ci}",
            "direcciones": ${datosCliente.direcciones.length == 0
        ? `[
                {
                "lat": "-17.51041339757574",
                "lng": "-63.164604605594825",
                "indicaciones": "Plaza Principal de Warnes, Santa Cruz.",
                "alias": "Ubicación de entrega"
                }
            ]`
        : JSON.stringify(datosCliente.direcciones)
      }
        }`;

    // Enfoque correcto: usar variables separadas para la consulta GraphQL
    const graphQLMutation = `
            mutation customerCreate($input: CustomerInput!) {
            customerCreate(input: $input) {
            customer {
                id
                firstName
                lastName
                email
                phone
                metafield(namespace: "informacion", key: "extra") {
                    id
                    namespace
                    key
                    value
                }
                }
                    userErrors {
                field
                message
                }
            }
            }
        `;

    // Crear el objeto de variables con datos válidos
    const variables = {
      input: {
        firstName: `${datosCliente.nombre} `,
        lastName: `${datosCliente.apellido} `,
        email: `${datosCliente.email} `,
        ...(datosCliente.celular &&
          datosCliente.celular.trim() !== "" && {
          phone: `+591${datosCliente.celular}`,
        }),
        metafields: [
          {
            namespace: "informacion",
            key: "extra",
            type: "json_string",
            value: metafieldValue,
          },
        ],
      },
    };

    try {
      const respuesta = await fetch(window.urlConsulta, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          query: graphQLMutation,
          variables: variables,
        }),
      });

      // Verificar respuesta de red
      if (!respuesta.ok) {
        const errorMsg = `Error de red: ${respuesta.status} ${respuesta.statusText} `;
        console.error(
          `ERROR crearUnNuevoUsuario: ${errorMsg} | URL: ${window.urlConsulta
          } | Variables: ${JSON.stringify(
            variables
          )} | Timestamp: ${new Date().toISOString()} `
        );
        throw new Error(
          "No se pudo conectar con el servidor. Por favor, verifica tu conexión a internet e intenta nuevamente."
        );
      }

      // Obtener el texto de la respuesta para debugging
      const respuestaTexto = await respuesta.text();

      // Intentar parsear la respuesta como JSON
      let datos;
      try {
        datos = JSON.parse(respuestaTexto);
      } catch (parseError) {
        console.error(
          `ERROR crearUnNuevoUsuario: Error al parsear JSON | Respuesta: ${respuestaTexto} | ParseError: ${parseError.message
          } | Variables: ${JSON.stringify(
            variables
          )} | Timestamp: ${new Date().toISOString()} `
        );
        throw new Error(
          "Error al procesar la información del servidor. Por favor, contacta al soporte técnico."
        );
      }

      console.log(
        `INFO crearUnNuevoUsuario: Datos de respuesta completa | Email: ${datosCliente.email
        } | Response: ${JSON.stringify(
          datos
        )} | Timestamp: ${new Date().toISOString()} `
      );

      // Verificar si hay errores en la respuesta de GraphQL
      if (datos.errors) {
        console.error(
          `ERROR crearUnNuevoUsuario: Errores de GraphQL | Errores: ${JSON.stringify(
            datos.errors
          )} | Email: ${datosCliente.email} | Variables: ${JSON.stringify(
            variables
          )} | Timestamp: ${new Date().toISOString()} `
        );
        throw new Error(
          "Error en la consulta de datos. Por favor, verifica la información e intenta nuevamente."
        );
      }

      // Verificar si hay errores específicos de la creación del usuario
      if (datos.data?.customerCreate?.userErrors?.length > 0) {
        const userErrors = datos.data.customerCreate.userErrors;
        console.error(
          `ERROR crearUnNuevoUsuario: Errores al crear usuario | UserErrors: ${JSON.stringify(
            userErrors
          )} | Email: ${datosCliente.email} | Variables: ${JSON.stringify(
            variables
          )} | Timestamp: ${new Date().toISOString()} `
        );

        // Buscar específicamente error de email duplicado
        const emailError = userErrors.find(
          (error) =>
            error.field &&
            error.field.includes("email") &&
            error.message &&
            (error.message.toLowerCase().includes("already exists") ||
              error.message.toLowerCase().includes("already been taken") ||
              error.message.toLowerCase().includes("has been taken"))
        );

        if (emailError) {
          throw new Error(
            "El correo electrónico ya está registrado. Por favor, intenta con otro correo."
          );
        }

        // Buscar errores de teléfono
        const phoneError = userErrors.find(
          (error) => error.field && error.field.includes("phone")
        );

        if (phoneError) {
          throw new Error(
            "El número de teléfono no es válido o ya está registrado."
          );
        }

        // Para otros tipos de errores
        throw new Error(
          "Revisa tus datos, por favor. Algunos campos contienen información inválida."
        );
      }

      // Verificar si se creó el cliente
      if (datos.data?.customerCreate?.customer) {
        const customer = datos.data.customerCreate.customer;

        // Extraer el metafield
        let metafieldData = {};
        if (customer.metafield?.value) {
          try {
            metafieldData = JSON.parse(customer.metafield.value);
          } catch (metafieldError) {
            console.error(
              `ERROR crearUnNuevoUsuario: Error al parsear metafield JSON | MetafieldError: ${metafieldError.message
              } | Valor: ${customer.metafield.value} | CustomerID: ${customer.id
              } | Email: ${datosCliente.email
              } | Timestamp: ${new Date().toISOString()} `
            );
            // No lanzar error aquí, solo log, porque el usuario se creó exitosamente
          }
        }

        console.log(
          `SUCCESS crearUnNuevoUsuario: Usuario creado exitosamente | CustomerID: ${customer.id
          } | Email: ${customer.email
          } | Timestamp: ${new Date().toISOString()} `
        );

        // Construir y devolver el objeto con toda la información
        return {
          id: customer.id,
          nombre: customer.firstName,
          celular: customer.phone ? customer.phone.replace("+591", "") : "",
          apellido: customer.lastName,
          email: customer.email,
          ci: metafieldData.ci || "",
          direcciones: metafieldData.direcciones || [],
          razon_social: metafieldData.razon_social || "",
          nit: metafieldData.nit || "",
          fecha_nacimiento: metafieldData.fecha || "",
          permisosHutCoins: metafieldData.permisosHutCoins || false,
        };
      } else {
        console.error(
          `ERROR crearUnNuevoUsuario: No se pudo crear el usuario, respuesta inesperada | Respuesta: ${JSON.stringify(
            datos
          )} | Email: ${datosCliente.email} | Variables: ${JSON.stringify(
            variables
          )} | Timestamp: ${new Date().toISOString()} `
        );
        throw new Error(
          "No se pudo crear el usuario. Por favor, intenta nuevamente."
        );
      }
    } catch (error) {
      // Si es un error que ya lanzamos con mensaje personalizado, solo lo re-lanzamos
      if (
        error.message.includes("correo electrónico ya está registrado") ||
        error.message.includes("número de teléfono no es válido") ||
        error.message.includes("Revisa tus datos") ||
        error.message.includes("No se pudo conectar") ||
        error.message.includes("Error al procesar la información") ||
        error.message.includes("Error en la consulta") ||
        error.message.includes("No se pudo crear el usuario")
      ) {
        throw error;
      }

      // Log detallado para errores no manejados
      console.error(
        `ERROR crearUnNuevoUsuario: Error inesperado | Error: ${error.message
        } | Email: ${datosCliente.email} | Tipo: ${error.constructor.name
        } | Stack: ${error.stack} | Variables: ${JSON.stringify(
          variables
        )} | Timestamp: ${new Date().toISOString()} `
      );

      // Determinar mensaje amigable para errores no manejados
      let mensajeUsuario = "";
      if (
        error.message.includes("fetch") ||
        error.message.includes("network")
      ) {
        mensajeUsuario =
          "Problema de conexión. Por favor, intenta nuevamente en unos momentos.";
      } else if (
        error.message.includes("JSON") ||
        error.message.includes("parse")
      ) {
        mensajeUsuario =
          "Error al procesar la información del servidor. Por favor, contacta al soporte técnico.";
      } else if (
        error.message.includes("TypeError") ||
        error.message.includes("ReferenceError")
      ) {
        mensajeUsuario =
          "Error en el formato de datos. Por favor, contacta al soporte técnico.";
      } else if (error.message.includes("timeout")) {
        mensajeUsuario =
          "La solicitud tardó demasiado tiempo. Por favor, intenta nuevamente.";
      } else {
        mensajeUsuario =
          "Ha ocurrido un error inesperado al crear el usuario. Por favor, intenta nuevamente o contacta al soporte técnico.";
      }

      throw new Error(mensajeUsuario);
    }
  }

  static async validarCorreoElectronico(correoElectronico) {
    // Validaciones iniciales
    if (!correoElectronico || typeof correoElectronico !== "string") {
      const errorDetail = `Validación correo - Email inválido: ${correoElectronico} `;
      console.error(errorDetail);
      throw new Error("El correo electrónico es requerido y debe ser válido.");
    }

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(correoElectronico)) {
      const errorDetail = `Validación correo - Formato email inválido: ${correoElectronico} `;
      console.error(errorDetail);
      throw new Error("El formato del correo electrónico no es válido.");
    }

    // Validar configuración
    if (!window.urlConsulta) {
      const errorDetail = `Validación correo - Configuración faltante: URL = ${window.urlConsulta}`;
      console.error(errorDetail);
      throw new Error(
        "Error de configuración del sistema. Por favor, contacta al soporte técnico."
      );
    }

    const graphQLQuery = `
            query($identifier: CustomerIdentifierInput!) {
            customer: customerByIdentifier(identifier: $identifier) {
                id
                firstName
                lastName
                email
                phone
                metafield(namespace: "informacion", key: "extra") {
                id
                key
                namespace
                value
                }
            }
            }
        `;

    const variables = {
      identifier: {
        emailAddress: correoElectronico,
      },
    };

    try {
      const respuesta = await fetch(window.urlConsulta, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          query: graphQLQuery,
          variables: variables,
        }),
      });

      if (!respuesta.ok) {
        const errorDetail = `Validación correo - Error de red: ${respuesta.status} ${respuesta.statusText} | URL: ${window.urlConsulta} | Email: ${correoElectronico} `;
        console.error(errorDetail);

        // Manejo específico por código de estado
        switch (respuesta.status) {
          case 401:
            throw new Error(
              "Sesión expirada. Por favor, recarga la página e intenta nuevamente."
            );
          case 403:
            throw new Error("No tienes permisos para realizar esta operación.");
          case 429:
            throw new Error(
              "Demasiadas solicitudes. Por favor, espera un momento e intenta nuevamente."
            );
          case 500:
          case 502:
          case 503:
          case 504:
            throw new Error(
              "El servidor está temporalmente no disponible. Por favor, intenta más tarde."
            );
          default:
            throw new Error(
              "Error de conexión con el servidor. Por favor, intenta nuevamente."
            );
        }
      }

      let datos;
      try {
        datos = await respuesta.json();
        console.log(`Validación correo ${datos}`);
      } catch (parseError) {
        const errorDetail = `Validación correo - Error parseando respuesta: ${parseError.message} | Email: ${correoElectronico} `;
        console.error(errorDetail);
        throw new Error(
          "Error al procesar la respuesta del servidor. Por favor, intenta nuevamente."
        );
      }

      // Verificar errores de GraphQL
      if (datos.errors) {
        const errorDetail = `Validación correo - Errores GraphQL: ${JSON.stringify(
          datos.errors
        )} | Email: ${correoElectronico} `;
        console.error(errorDetail);

        // Buscar errores específicos
        const hasTimeoutError = datos.errors.some(
          (error) =>
            error.message?.toLowerCase().includes("timeout") ||
            error.message?.toLowerCase().includes("deadline")
        );

        if (hasTimeoutError) {
          throw new Error(
            "La operación tardó demasiado tiempo. Por favor, intenta nuevamente."
          );
        }

        throw new Error(
          "Error al consultar los datos. Por favor, intenta nuevamente."
        );
      }

      // Verificar estructura de respuesta
      if (!datos.data) {
        const errorDetail = `Validación correo - Respuesta sin data: ${JSON.stringify(
          datos
        )} | Email: ${correoElectronico} `;
        console.error(errorDetail);
        throw new Error(
          "Respuesta del servidor inválida. Por favor, intenta nuevamente."
        );
      }

      // Si no se encontró cliente, retornar null (no es error)
      if (!datos.data.customer) {
        console.log(
          `Validación correo - Cliente no encontrado: ${correoElectronico} `
        );
        return null;
      }

      const customer = datos.data.customer;

      // Validar datos del cliente
      if (!customer.id) {
        const errorDetail = `Validación correo - Cliente sin ID: ${JSON.stringify(
          customer
        )} | Email: ${correoElectronico} `;
        console.error(errorDetail);
        throw new Error(
          "Datos del cliente incompletos. Por favor, contacta al soporte técnico."
        );
      }

      // Procesar metafields
      let metafieldData = {};
      if (customer?.metafield?.value) {
        try {
          metafieldData = JSON.parse(customer.metafield.value);
        } catch (parseError) {
          const errorDetail = `Validación correo - Error parseando metafield: ${parseError.message} | Email: ${correoElectronico} | Metafield: ${customer.metafield.value} `;
          console.warn(errorDetail);
          // No lanzar error, usar objeto vacío
          metafieldData = {};
        }
      }

      console.log(
        `Validación correo - Cliente encontrado exitosamente: ${correoElectronico} | ID: ${customer.id} `
      );

      return {
        id: customer.id,
        nombre: customer.firstName || "",
        apellido: customer.lastName || "",
        email: customer.email || "",
        celular: customer.phone?.replace(/^\+591/, "") || "",
        ci: metafieldData.ci || "",
        direcciones: metafieldData.direcciones || [],
        razon_social: metafieldData.razon_social || "",
        nit: metafieldData.nit || "",
        fecha_nacimiento: metafieldData.fecha || "",
        permisosHutCoins: metafieldData.permisosHutCoins || false,
      };
    } catch (error) {
      // Si es un error que ya formateamos, relanzarlo
      if (
        error.message.includes("correo electrónico") ||
        error.message.includes("Sesión expirada") ||
        error.message.includes("No tienes permisos") ||
        error.message.includes("Demasiadas solicitudes") ||
        error.message.includes("servidor está temporalmente") ||
        error.message.includes("Error de conexión") ||
        error.message.includes("Error al procesar") ||
        error.message.includes("Error al consultar") ||
        error.message.includes("La operación tardó") ||
        error.message.includes("Respuesta del servidor") ||
        error.message.includes("Datos del cliente") ||
        error.message.includes("Error de configuración")
      ) {
        throw error;
      }

      // Errores de red específicos
      if (error.name === "TypeError" && error.message.includes("fetch")) {
        const errorDetail = `Validación correo - Error de red fetch: ${error.message} | Email: ${correoElectronico} `;
        console.error(errorDetail);
        throw new Error(
          "Error de conexión. Verifica tu conexión a internet e intenta nuevamente."
        );
      }

      if (error.name === "AbortError") {
        const errorDetail = `Validación correo - Timeout: ${error.message} | Email: ${correoElectronico} `;
        console.error(errorDetail);
        throw new Error(
          "La operación tardó demasiado tiempo. Por favor, intenta nuevamente."
        );
      }

      // Error no previsto
      const errorDetail = `Validación correo - Error inesperado: ${error.message} | Email: ${correoElectronico} | Stack: ${error.stack} `;
      console.error(errorDetail);
      throw new Error(
        "Ha ocurrido un error inesperado. Por favor, contacta al soporte técnico."
      );
    }
  }

  static async validarNumeroTelefono(numeroTelefono) {
    // Validaciones iniciales
    if (!numeroTelefono || typeof numeroTelefono !== "string") {
      const errorDetail = `Validación teléfono - Teléfono inválido: ${numeroTelefono} `;
      console.error(errorDetail);
      throw new Error("El número de teléfono es requerido y debe ser válido.");
    }

    // Validar formato básico (solo números, puede tener espacios o guiones)
    const phonePattern = /^[\d\s\-+()]+$/;
    if (!phonePattern.test(numeroTelefono)) {
      const errorDetail = `Validación teléfono - Formato teléfono inválido: ${numeroTelefono} `;
      console.error(errorDetail);
      throw new Error("El formato del número de teléfono no es válido.");
    }

    // Validar configuración
    if (!window.urlConsulta) {
      const errorDetail = `Validación teléfono - Configuración faltante: URL = ${window.urlConsulta}`;
      console.error(errorDetail);
      throw new Error(
        "Error de configuración del sistema. Por favor, contacta al soporte técnico."
      );
    }

    const graphQLQuery = `
    query($identifier: CustomerIdentifierInput!) {
      customer: customerByIdentifier(identifier: $identifier) {
        id
        firstName
        lastName
        email
        phone
        metafield(namespace: "informacion", key: "extra") {
          id
          key
          namespace
          value
        }
      }
    }
    `;

    const variables = {
      identifier: {
        phoneNumber: numeroTelefono,
      },
    };

    try {
      const respuesta = await fetch(window.urlConsulta, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          query: graphQLQuery,
          variables: variables,
        }),
      });

      if (!respuesta.ok) {
        const errorDetail = `Validación teléfono - Error de red: ${respuesta.status} ${respuesta.statusText} | URL: ${window.urlConsulta} | Teléfono: ${numeroTelefono} `;
        console.error(errorDetail);

        // Manejo específico por código de estado
        switch (respuesta.status) {
          case 401:
            throw new Error(
              "Sesión expirada. Por favor, recarga la página e intenta nuevamente."
            );
          case 403:
            throw new Error("No tienes permisos para realizar esta operación.");
          case 429:
            throw new Error(
              "Demasiadas solicitudes. Por favor, espera un momento e intenta nuevamente."
            );
          case 500:
          case 502:
          case 503:
          case 504:
            throw new Error(
              "El servidor está temporalmente no disponible. Por favor, intenta más tarde."
            );
          default:
            throw new Error(
              "Error de conexión con el servidor. Por favor, intenta nuevamente."
            );
        }
      }

      let datos;
      try {
        datos = await respuesta.json();
      } catch (parseError) {
        const errorDetail = `Validación teléfono - Error parseando respuesta: ${parseError.message} | Teléfono: ${numeroTelefono} `;
        console.error(errorDetail);
        throw new Error(
          "Error al procesar la respuesta del servidor. Por favor, intenta nuevamente."
        );
      }

      // Verificar errores de GraphQL
      if (datos.errors) {
        const errorDetail = `Validación teléfono - Errores GraphQL: ${JSON.stringify(
          datos.errors
        )} | Teléfono: ${numeroTelefono} `;
        console.error(errorDetail);

        // Buscar errores específicos
        const hasTimeoutError = datos.errors.some(
          (error) =>
            error.message?.toLowerCase().includes("timeout") ||
            error.message?.toLowerCase().includes("deadline")
        );

        if (hasTimeoutError) {
          throw new Error(
            "La operación tardó demasiado tiempo. Por favor, intenta nuevamente."
          );
        }

        throw new Error(
          "Error al consultar los datos. Por favor, intenta nuevamente."
        );
      }

      // Verificar estructura de respuesta
      if (!datos.data) {
        const errorDetail = `Validación teléfono - Respuesta sin data: ${JSON.stringify(
          datos
        )} | Teléfono: ${numeroTelefono} `;
        console.error(errorDetail);
        throw new Error(
          "Respuesta del servidor inválida. Por favor, intenta nuevamente."
        );
      }

      // Si no se encontró cliente, retornar null (no es error)
      if (!datos.data.customer) {
        console.log(
          `Validación teléfono - Cliente no encontrado: ${numeroTelefono} `
        );
        return null;
      }

      const customer = datos.data.customer;

      // Validar datos del cliente
      if (!customer.id) {
        const errorDetail = `Validación teléfono - Cliente sin ID: ${JSON.stringify(
          customer
        )} | Teléfono: ${numeroTelefono} `;
        console.error(errorDetail);
        throw new Error(
          "Datos del cliente incompletos. Por favor, contacta al soporte técnico."
        );
      }

      // Procesar metafields
      let metafieldData = {};
      if (customer?.metafield?.value) {
        try {
          metafieldData = JSON.parse(customer.metafield.value);
        } catch (parseError) {
          const errorDetail = `Validación teléfono - Error parseando metafield: ${parseError.message} | Teléfono: ${numeroTelefono} | Metafield: ${customer.metafield.value} `;
          console.warn(errorDetail);
          metafieldData = {};
        }
      }

      console.log(
        `Validación teléfono - Cliente encontrado exitosamente: ${numeroTelefono} | ID: ${customer.id} `
      );

      return {
        id: customer.id,
        nombre: customer.firstName || "",
        apellido: customer.lastName || "",
        email: customer.email || "",
        celular: customer.phone?.replace(/^\+591/, "") || "",
        ci: metafieldData.ci || "",
        direcciones: metafieldData.direcciones || [],
        razon_social: metafieldData.razon_social || "",
        nit: metafieldData.nit || "",
        fecha_nacimiento: metafieldData.fecha || "",
        permisosHutCoins: metafieldData.permisosHutCoins || false,
      };
    } catch (error) {
      // Si es un error que ya formateamos, relanzarlo
      if (
        error.message.includes("número de teléfono") ||
        error.message.includes("Sesión expirada") ||
        error.message.includes("No tienes permisos") ||
        error.message.includes("Demasiadas solicitudes") ||
        error.message.includes("servidor está temporalmente") ||
        error.message.includes("Error de conexión") ||
        error.message.includes("Error al procesar") ||
        error.message.includes("Error al consultar") ||
        error.message.includes("La operación tardó") ||
        error.message.includes("Respuesta del servidor") ||
        error.message.includes("Datos del cliente") ||
        error.message.includes("Error de configuración")
      ) {
        throw error;
      }

      // Errores de red específicos
      if (error.name === "TypeError" && error.message.includes("fetch")) {
        const errorDetail = `Validación teléfono - Error de red fetch: ${error.message} | Teléfono: ${numeroTelefono} `;
        console.error(errorDetail);
        throw new Error(
          "Error de conexión. Verifica tu conexión a internet e intenta nuevamente."
        );
      }

      if (error.name === "AbortError") {
        const errorDetail = `Validación teléfono - Timeout: ${error.message} | Teléfono: ${numeroTelefono} `;
        console.error(errorDetail);
        throw new Error(
          "La operación tardó demasiado tiempo. Por favor, intenta nuevamente."
        );
      }

      // Error no previsto
      const errorDetail = `Validación teléfono - Error inesperado: ${error.message} | Teléfono: ${numeroTelefono} | Stack: ${error.stack} `;
      console.error(errorDetail);
      throw new Error(
        "Ha ocurrido un error inesperado. Por favor, contacta al soporte técnico."
      );
    }
  }

  // Verificar si el correo electrónico es usado en el flujo de whatsapp
  static async correoUsadoFlujoWhatsapp(correoElectronico) {
    try {
      if (!correoElectronico || !correoElectronico.includes("@")) {
        throw ManejadorErrores.crearError(
          ManejadorErrores.CODIGOS_ERROR.ERROR_CORREO,
          { correo: correoElectronico }
        );
      }

      const consulta = `
        query PedidosPorCanalYCorreo {
          orders(
            first: 10, 
            query: "channel_id:261397217564 email:${correoElectronico}"
          ) {
            edges {
              node {
                id
                name
                email
                channelInformation {
                  channelId
                }
              }
            }
          }
        }
      `;

      const respuesta = await fetch(window.urlConsulta, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ query: consulta }),
      });

      if (!respuesta.ok) {
        throw ManejadorErrores.crearError(
          ManejadorErrores.CODIGOS_ERROR.ERROR_SHOPIFY,
          {
            estado: respuesta.status,
            texto: respuesta.statusText,
          }
        );
      }

      const datos = await respuesta.json();

      if (datos.errors) {
        throw ManejadorErrores.crearError(
          ManejadorErrores.CODIGOS_ERROR.ERROR_CONSULTA,
          datos.errors
        );
      }

      const pedidos = datos.data?.orders?.edges || [];

      // Console.log de la respuesta completa
      console.log('Respuesta de pedidos por WhatsApp:', pedidos);

      // Retornar true si hay al menos 1 pedido, false si no hay ninguno
      return pedidos.length > 0;

    } catch (error) {
      return ManejadorErrores.manejarError(error, "correoUsadoFlujoWhatsapp");
    }
  }

  // Fusionar 2 clientes en Shopify
  static async fusionarClientesShopify(cliente_1, cliente_2) {
    try {
      // Validación de parámetros
      if (!cliente_1?.id || !cliente_2?.id) {
        throw ManejadorErrores.crearError(
          ManejadorErrores.CODIGOS_ERROR.ERROR_VALIDACION,
          {
            cliente_1: cliente_1?.id || 'no definido',
            cliente_2: cliente_2?.id || 'no definido'
          }
        );
      }

      // Primera consulta: Fusionar clientes
      const query_1 = `
              mutation FusionarClientes {
                  customerMerge(
                      customerOneId: "${cliente_1.id}",
                      customerTwoId: "${cliente_2.id}",
                      overrideFields: {
                          customerIdOfFirstNameToKeep: "${cliente_1.id}",
                          customerIdOfLastNameToKeep: "${cliente_1.id}",
                          customerIdOfEmailToKeep: "${cliente_1.id}",
                          customerIdOfPhoneNumberToKeep: "${cliente_2.id}"
                      }
                  ) {
                      resultingCustomerId
                      job {
                          id
                          done
                      }
                      userErrors {
                          code
                          field
                          message
                      }
                  }
              }
          `;

      console.log('Ejecutando fusión de clientes...');
      const respuesta_1 = await fetch(window.urlConsulta, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ query: query_1 }),
      });

      if (!respuesta_1.ok) {
        throw ManejadorErrores.crearError(
          ManejadorErrores.CODIGOS_ERROR.ERROR_SHOPIFY,
          {
            estado: respuesta_1.status,
            texto: respuesta_1.statusText,
            operacion: 'Fusión de clientes'
          }
        );
      }

      const datos_1 = await respuesta_1.json();

      if (datos_1.errors) {
        throw ManejadorErrores.crearError(
          ManejadorErrores.CODIGOS_ERROR.ERROR_CONSULTA,
          {
            errores: datos_1.errors,
            operacion: 'Fusión de clientes'
          }
        );
      }

      // Verificar errores de usuario en la fusión
      if (datos_1.data?.customerMerge?.userErrors?.length > 0) {
        const erroresUsuario = datos_1.data.customerMerge.userErrors;
        throw ManejadorErrores.crearError(
          ManejadorErrores.CODIGOS_ERROR.ERROR_NEGOCIO,
          {
            errores: erroresUsuario,
            operacion: 'Fusión de clientes'
          }
        );
      }

      const clienteResultanteId = datos_1.data?.customerMerge?.resultingCustomerId;
      console.log('Fusión exitosa. Cliente resultante:', clienteResultanteId);

      // Lógica para determinar qué datos usar
      const cliente1TieneMetafields = cliente_1.direcciones && cliente_1.direcciones.length > 0;

      // Preparar datos para metafields
      const datosMetafields = {
        ci: cliente1TieneMetafields ? cliente_1.ci : cliente_2.ci || "",
        nit: cliente1TieneMetafields ? cliente_1.nit : cliente_2.nit || "",
        razon_social: cliente1TieneMetafields ? cliente_1.razon_social : cliente_2.razon_social || "",
        fecha: cliente1TieneMetafields ? cliente_1.fecha_nacimiento : cliente_2.fecha_nacimiento || "",
        permisosHutCoins: cliente1TieneMetafields ? cliente_1.permisosHutCoins : cliente_2.permisosHutCoins || false,
        direcciones: cliente1TieneMetafields
          ? [
            ...cliente_1.direcciones,
            ...cliente_2.direcciones.filter(direccion => {
              // Verificar si cumple TODAS las condiciones para eliminar
              const esDireccionPorDefecto =
                direccion.lat === "-17.51041339757574" &&
                direccion.lng === "-63.164604605594825" &&
                direccion.alias === "Ubicación de entrega" &&
                direccion.indicaciones === "Plaza Principal de Warnes, Santa Cruz.";

              // Retornar true para mantener, false para eliminar
              return !esDireccionPorDefecto;
            })
          ]
          : cliente_2.direcciones || []
      };

      // Segunda consulta: Actualizar metafields del cliente resultante
      const query_2 = `
              mutation ActualizarMetafieldsCliente {
                  customerUpdate(input: {
                      id: "${clienteResultanteId}",
                      metafields: [
                          {
                              namespace: "informacion",
                              key: "extra",
                              type: "json_string",
                              value: "${JSON.stringify(datosMetafields).replace(/"/g, '\\"')}"
                          }
                      ]
                  }) {
                      customer {
                          id
                          firstName
                          lastName
                          email
                          phone
                          metafield(namespace: "informacion", key: "extra") {
                              id
                              key
                              namespace
                              value
                          }
                      }
                      userErrors {
                          message
                          field
                      }
                  }
              }
          `;

      console.log('Actualizando metafields del cliente...');
      const respuesta_2 = await fetch(window.urlConsulta, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ query: query_2 }),
      });

      if (!respuesta_2.ok) {
        throw ManejadorErrores.crearError(
          ManejadorErrores.CODIGOS_ERROR.ERROR_SHOPIFY,
          {
            estado: respuesta_2.status,
            texto: respuesta_2.statusText,
            operacion: 'Actualización de metafields'
          }
        );
      }

      const datos_2 = await respuesta_2.json();

      if (datos_2.errors) {
        throw ManejadorErrores.crearError(
          ManejadorErrores.CODIGOS_ERROR.ERROR_CONSULTA,
          {
            errores: datos_2.errors,
            operacion: 'Actualización de metafields'
          }
        );
      }

      // Verificar errores de usuario en la actualización
      if (datos_2.data?.customerUpdate?.userErrors?.length > 0) {
        const erroresUsuario = datos_2.data.customerUpdate.userErrors;
        throw ManejadorErrores.crearError(
          ManejadorErrores.CODIGOS_ERROR.ERROR_NEGOCIO,
          {
            errores: erroresUsuario,
            operacion: 'Actualización de metafields'
          }
        );
      }

      console.log('Metafields actualizados exitosamente');

      // Procesar los datos del cliente fusionado
      const customer = datos_2.data?.customerUpdate?.customer;

      // Procesar metafields
      let metafieldData = {};
      if (customer?.metafield?.value) {
        try {
          metafieldData = JSON.parse(customer.metafield.value);
        } catch (parseError) {
          console.warn('Error parseando metafield:', parseError.message);
          metafieldData = {};
        }
      }

      // Crear objeto Cliente con los datos de la segunda consulta
      const clienteFusionado = new Cliente(
        customer.id,
        customer.firstName || "",
        customer.lastName || "",
        customer.email || "",
        customer.phone?.replace(/^\+591/, "") || "",
        metafieldData.ci || "",
        metafieldData.nit || "",
        metafieldData.fecha || "",
        metafieldData.permisosHutCoins || false,
        metafieldData.razon_social || "",
        metafieldData.direcciones || []
      );

      console.log('Cliente fusionado:', clienteFusionado);

      return clienteFusionado;

    } catch (error) {
      return ManejadorErrores.manejarError(error, "fusionarClientesShopify");
    }
  }

  // Proceso Actualizacion(EDITAR) de datos del usuario
  static async procesoActualizarDatosUsuario(valoresInputs) {
    try {
      // Validaciones iniciales
      const usuarioLocalStorage = JSON.parse(
        localStorage.getItem("ph-datos-usuario")
      );
      const correoElectronico = valoresInputs.email;
      const numeroTelefono = valoresInputs.celular;
      const validarCorreoElectronico =
        await GestorClienteShopify.validarCorreoElectronico(correoElectronico);
      const validarNumeroTelefono =
        await GestorClienteShopify.validarNumeroTelefono(
          "+591" + numeroTelefono
        );
      const correoUsadoFlujoWhatsapp =
        await GestorClienteShopify.correoUsadoFlujoWhatsapp(correoElectronico);

      // Preparar direcciones de personalización (las nuevas que vienen del input)
      var direccionesPersonalizacion = [];
      direccionesPersonalizacion = valoresInputs.direcciones.map(
        (direccion) => {
          return {
            lat: direccion.lat,
            lng: direccion.lng,
            indicaciones: direccion.indicaciones,
            alias: direccion.alias,
          };
        }
      );

      // Lista final de direcciones - EMPEZAR CON LAS DIRECCIONES NUEVAS
      let direccionesFinal = [...direccionesPersonalizacion];

      // Datos base del cliente
      const datosCliente = {
        id: null,
        nombre: valoresInputs.nombre,
        apellido: valoresInputs.apellido,
        email: valoresInputs.email,
        celular: valoresInputs.celular,
        ci: valoresInputs.ci,
        nit: valoresInputs.nit,
        direcciones: direccionesFinal,
        razon_social: valoresInputs.razon_social,
        fecha_nacimiento: valoresInputs.fecha_nacimiento,
        permisosHutCoins: valoresInputs.permisosHutCoins,
      };

      console.log("¿Tiene pedidos por WhatsApp?", {
        correoUsadoFlujoWhatsapp,
        validarCorreoElectronico,
        validarNumeroTelefono,
        direccionesFinal
      });

      if (correoUsadoFlujoWhatsapp) {
        const clienteConDireccionesFinal = {
          ...validarCorreoElectronico,
          direcciones: direccionesFinal.filter(direccion => {
            // Verificar si cumple TODAS las condiciones para eliminar
            const esDireccionPorDefecto =
              direccion.lat === "-17.51041339757574" &&
              direccion.lng === "-63.164604605594825" &&
              direccion.alias === "Ubicación de entrega" &&
              direccion.indicaciones === "Plaza Principal de Warnes, Santa Cruz.";

            // Retornar true para mantener, false para eliminar
            return !esDireccionPorDefecto;
          })
        };

        const clienteFusionado =
          await GestorClienteShopify.fusionarClientesShopify(clienteConDireccionesFinal, validarNumeroTelefono);

        localStorage.setItem("clienteFusionado", JSON.stringify(clienteFusionado));
      }

      let cliente = null;

      // Analisis de casos y logica mejorada
      const emailExiste = validarCorreoElectronico !== null;
      const telefonoExiste = validarNumeroTelefono !== null;

      // CASO 1: Ambos existen y pertenecen al mismo usuario (el actual) - CASO IDEAL
      if (
        emailExiste &&
        telefonoExiste &&
        validarCorreoElectronico.id == usuarioLocalStorage.id &&
        validarNumeroTelefono.id == usuarioLocalStorage.id &&
        validarCorreoElectronico.id == validarNumeroTelefono.id
      ) {
        datosCliente.id = validarCorreoElectronico.id;
        cliente = await GestorClienteShopify.actualizarDatosUsuarioNew(
          datosCliente
        );
      }
      // CASO 2: Solo email existe y pertenece al usuario actual
      else if (
        emailExiste &&
        validarCorreoElectronico.id == usuarioLocalStorage.id &&
        !telefonoExiste
      ) {
        datosCliente.id = validarCorreoElectronico.id;
        cliente = await GestorClienteShopify.actualizarDatosUsuarioNew(
          datosCliente
        );
      }
      // CASO 3: Solo teléfono existe y pertenece al usuario actual
      else if (
        telefonoExiste &&
        validarNumeroTelefono.id == usuarioLocalStorage.id &&
        !emailExiste
      ) {
        datosCliente.id = validarNumeroTelefono.id;
        cliente = await GestorClienteShopify.actualizarDatosUsuarioNew(
          datosCliente
        );
      }
      // CASO 4: Ninguno existe - Crear nuevos datos (caso menos común en edición)
      else if (!emailExiste && !telefonoExiste) {
        datosCliente.id = usuarioLocalStorage.id;
        cliente = await GestorClienteShopify.actualizarDatosUsuarioNew(
          datosCliente
        );
      }
      // ERRORES - Casos que impiden la actualización
      // CASO 5: Email existe pero pertenece a otro usuario
      else if (
        emailExiste &&
        validarCorreoElectronico.id != usuarioLocalStorage.id
      ) {
        MensajeCargaDatos.ocultar();
        MensajeTemporal.mostrarMensaje(
          "El correo electrónico ya está registrado por otro usuario.",
          "error",
          3500
        );
        return { success: false };
      }
      // CASO 6: Teléfono existe pero pertenece a otro usuario
      else if (
        telefonoExiste &&
        validarNumeroTelefono.id != usuarioLocalStorage.id
      ) {
        console.log("Error en el caso 6");
        MensajeCargaDatos.ocultar();
        MensajeTemporal.mostrarMensaje(
          "El número de celular ya está registrado por otro usuario.",
          "error",
          3500
        );
        return { success: false };
      }
      // CASO 7: Ambos existen pero pertenecen a usuarios diferentes
      else if (
        emailExiste &&
        telefonoExiste &&
        (validarCorreoElectronico.id != validarNumeroTelefono.id ||
          validarCorreoElectronico.id != usuarioLocalStorage.id ||
          validarNumeroTelefono.id != usuarioLocalStorage.id)
      ) {
        MensajeCargaDatos.ocultar();
        MensajeTemporal.mostrarMensaje(
          "El correo y el número de celular pertenecen a usuarios diferentes.",
          "error",
          3500
        );
        return { success: false };
      }
      // CASO 8: Cualquier otro caso no contemplado
      else {
        MensajeCargaDatos.ocultar();
        MensajeTemporal.mostrarMensaje(
          "Error en la validación de datos. Por favor, verifica la información.",
          "error",
          3500
        );
        return { success: false };
      }

      // Verificar si la actualización fue exitosa
      if (!cliente) {
        MensajeCargaDatos.ocultar();
        MensajeTemporal.mostrarMensaje(
          "No se pudo actualizar la información del usuario.",
          "error",
          3500
        );
        return { success: false };
      }

      // Verificar si hay error en la respuesta del cliente
      if (cliente.error) {
        MensajeCargaDatos.ocultar();
        MensajeTemporal.mostrarMensaje(cliente.error, "error", 3500);
        return { success: false };
      }

      // Guardar en localStorage solo si el cliente fue procesado exitosamente
      const datosParaGuardar = {
        id: cliente.id,
        nombre: cliente.nombre,
        celular: cliente.celular,
        apellido: cliente.apellido,
        email: cliente.email,
        ci: cliente.ci,
        direcciones: cliente.direcciones,
        razon_social: cliente.razon_social,
        nit: cliente.nit,
        fecha_nacimiento: cliente.fecha_nacimiento,
        permisosHutCoins: cliente.permisosHutCoins,
      };

      localStorage.setItem(
        "ph-datos-usuario",
        JSON.stringify(datosParaGuardar)
      );

      if (!window.location.href.includes("/pages/checkout-ph")) {
        // Mostrar mensaje de éxito
        MensajeCargaDatos.ocultar();

        // Volver a la página anterior o ir al inicio
        if (document.referrer && document.referrer !== window.location.href) {
          window.location.replace(document.referrer);
        } else {
          window.location.replace("/");
        }
      }
    } catch (error) {
      MensajeCargaDatos.ocultar();
      console.error("Error en procesoActualizarDatosUsuario:", error);
      MensajeTemporal.mostrarMensaje(
        error.message || "Error inesperado al actualizar los datos.",
        "error",
        3500
      );
      return { success: false };
    }
  }

  // Proceso Manejo Cliente para el empleado Contact Center
  static async procesoManejoClienteEmpleadoCC(valoresInputs) {
    try {
      // Validaciones iniciales
      const correoElectronico = valoresInputs.email;
      const numeroTelefono = valoresInputs.celular;
      const validarCorreoElectronico =
        await GestorClienteShopify.validarCorreoElectronico(correoElectronico);
      const validarNumeroTelefono =
        await GestorClienteShopify.validarNumeroTelefono(
          "+591" + numeroTelefono
        );

      // Preparar direcciones de personalización
      var direccionesPersonalizacion = [];
      direccionesPersonalizacion = valoresInputs.direcciones.map(
        (direccion) => {
          return {
            lat: direccion.lat,
            lng: direccion.lng,
            indicaciones: direccion.indicaciones,
            alias: direccion.alias,
          };
        }
      );

      // Lista final de direcciones - EMPEZAR CON LAS DIRECCIONES NUEVAS
      let direccionesFinal = [...direccionesPersonalizacion];

      // Función para verificar si una dirección ya existe (comparar lat, lng)
      const direccionExiste = (nuevaDireccion, listaDirecciones) => {
        return listaDirecciones.some(
          (direccion) =>
            direccion.lat === nuevaDireccion.lat &&
            direccion.lng === nuevaDireccion.lng
        );
      };

      // Agregar direcciones existentes del cliente encontrado
      let direccionesExistentes = [];

      if (validarCorreoElectronico !== null) {
        direccionesExistentes = validarCorreoElectronico.direcciones || [];
      } else if (validarNumeroTelefono !== null) {
        direccionesExistentes = validarNumeroTelefono.direcciones || [];
      }

      // INSERTAR direcciones existentes AL INICIO, pero solo si no existen ya
      direccionesExistentes.forEach((direccionExistente) => {
        if (!direccionExiste(direccionExistente, direccionesFinal)) {
          direccionesFinal.unshift(direccionExistente);
        }
      });

      // Datos base del cliente
      const datosCliente = {
        id: null,
        nombre: valoresInputs.nombre,
        apellido: valoresInputs.apellido,
        email: valoresInputs.email,
        celular: valoresInputs.celular,
        ci: valoresInputs.ci,
        nit: valoresInputs.nit,
        direcciones: direccionesFinal,
        razon_social: valoresInputs.razon_social,
        fecha_nacimiento: valoresInputs.fecha_nacimiento,
        permisosHutCoins: valoresInputs.permisosHutCoins,
      };

      let cliente = null;
      var codigoEnviadoCliente = GestorClienteShopify.generarCodigoTemporal();

      // Análisis de casos y lógica mejorada
      const emailExiste = validarCorreoElectronico !== null;
      const telefonoExiste = validarNumeroTelefono !== null;

      // CASO IMPORTANTE: Validar que no sea un empleado Contact Center
      if (
        emailExiste &&
        window.empleadosCallCenter.includes(validarCorreoElectronico.id)
      ) {
        MensajeCargaDatos.ocultar();
        MensajeTemporal.mostrarMensaje(
          "No sea dañino por favor! Este email está reservado para Contact Center",
          "error",
          3500
        );
        return { success: false };
      }

      if (
        telefonoExiste &&
        window.empleadosCallCenter.includes(validarNumeroTelefono.id)
      ) {
        MensajeCargaDatos.ocultar();
        MensajeTemporal.mostrarMensaje(
          "No sea dañino por favor! Este teléfono está reservado para Contact Center",
          "error",
          3500
        );
        return { success: false };
      }

      // CASO 1: Ambos existen y pertenecen al mismo cliente
      if (
        emailExiste &&
        telefonoExiste &&
        validarCorreoElectronico.id == validarNumeroTelefono.id
      ) {
        console.log("Error en el caso 1");
        datosCliente.id = validarNumeroTelefono.id;
        cliente = await GestorClienteShopify.actualizarDatosUsuarioNew(
          datosCliente
        );
      }

      // CASO 2: Solo email existe - se tomará como pivote de datos
      else if (emailExiste && !telefonoExiste) {
        console.log("Error en el caso 2");

        datosCliente.id = validarCorreoElectronico.id;

        // CASO ESPECIAL: El email es auxiliar, crear un nuevo usuario con telefono real
        if (validarCorreoElectronico.email == "contac.center.aux@gmail.com" || validarCorreoElectronico.email == "contac.center.farmacorp@gmail.com"){
          // Generar email temporal único para este usuario
          datosCliente.id = null;
          datosCliente.nombre =
            valoresInputs.nombre?.trim().toLowerCase() == "sinnombre"
              ? `pizzaHut${codigoEnviadoCliente}`
              : valoresInputs.nombre;
          datosCliente.apellido =
            valoresInputs.apellido?.trim().toLowerCase() == "sinnombre"
              ? `pizzaHut${codigoEnviadoCliente}`
              : valoresInputs.apellido;
          datosCliente.email = `pizzaHut${codigoEnviadoCliente}@gmail.com`;
          datosCliente.celular = valoresInputs.celular;
          datosCliente.ci = valoresInputs.ci;
          datosCliente.nit = valoresInputs.nit;
          datosCliente.razon_social = valoresInputs.razon_social;
          datosCliente.fecha_nacimiento = "";
          datosCliente.permisosHutCoins = false;
          datosCliente.direcciones = direccionesFinal;

          // Email real, proceder normalmente
          cliente = await GestorClienteShopify.crearNuevoClienteShopify(
            datosCliente
          );
        } else {
          // Email real, proceder normalmente
          cliente = await GestorClienteShopify.actualizarDatosUsuarioNew(
            datosCliente
          );
        }
      }

      // CASO 3: Solo teléfono existe
      else if (telefonoExiste && !emailExiste) {
        console.log("Error en el caso 3");

        datosCliente.id = validarNumeroTelefono.id;
        datosCliente.email = correoElectronico;
        cliente = await GestorClienteShopify.actualizarDatosUsuarioNew(
          datosCliente
        );
      }

      // CASO 4: Ninguno existe - Crear nuevo cliete
      else if (!emailExiste && !telefonoExiste) {
        console.log("Error en el caso 4");

        // CASO ESPECIAL: Usuario no quiere dar su email (usar email auxiliar)
        if (correoElectronico == "contac.center.aux@gmail.com" || validarCorreoElectronico.email == "contac.center.farmacorp@gmail.com") {
          // Generar email temporal único para este usuario
          datosCliente.nombre =
            valoresInputs.nombre?.trim().toLowerCase() == "sinnombre"
              ? `pizzaHut${codigoEnviadoCliente}`
              : valoresInputs.nombre;
          datosCliente.apellido =
            valoresInputs.apellido?.trim().toLowerCase() == "sinnombre"
              ? `pizzaHut${codigoEnviadoCliente}`
              : valoresInputs.apellido;
          datosCliente.email = `pizzaHut${codigoEnviadoCliente}@gmail.com`;
          datosCliente.celular = valoresInputs.celular;
          datosCliente.ci = valoresInputs.ci;
          datosCliente.nit = valoresInputs.nit;
          datosCliente.razon_social = valoresInputs.razon_social;
          datosCliente.fecha_nacimiento = "";
          datosCliente.permisosHutCoins = false;
          datosCliente.direcciones = direccionesFinal;
        }

        cliente = await GestorClienteShopify.crearNuevoClienteShopify(
          datosCliente
        );
      }

      // CASO 5: Ambos existen pero pertenecen a clientes diferentes - ERROR
      else if (
        emailExiste &&
        telefonoExiste &&
        validarCorreoElectronico.id !== validarNumeroTelefono.id
      ) {
        console.log("Error en el caso 5");

        // CASO ESPECIAL: Usuario no quiere dar su email (usar email auxiliar)
        if (
          emailExiste &&
          validarCorreoElectronico.email == "contac.center.aux@gmail.com" || validarCorreoElectronico.email == "contac.center.farmacorp@gmail.com"
        ) {
          // Usar todos los datos del teléfono porque el email es auxiliar
          datosCliente.id = validarNumeroTelefono.id;
          datosCliente.nombre = validarNumeroTelefono.nombre;
          datosCliente.apellido = validarNumeroTelefono.apellido;
          datosCliente.email = validarNumeroTelefono.email;
          datosCliente.ci = validarNumeroTelefono.ci;
          datosCliente.nit = validarNumeroTelefono.nit;
          datosCliente.razon_social = validarNumeroTelefono.razon_social;
          datosCliente.fecha_nacimiento =
            validarNumeroTelefono.fecha_nacimiento;
          datosCliente.permisosHutCoins =
            validarNumeroTelefono.permisosHutCoins;

          // Solo actualizar las direcciones nuevas y el número de teléfono si cambió
          datosCliente.celular = valoresInputs.celular;
          datosCliente.direcciones = direccionesFinal;

          cliente = await GestorClienteShopify.actualizarDatosUsuarioNew(
            datosCliente
          );
        } else {
          MensajeCargaDatos.ocultar();
          MensajeTemporal.mostrarMensaje(
            "El correo electrónico y el número de celular pertenecen a clientes diferentes. No se puede proceder.",
            "error",
            3500
          );
          return { success: false };
        }
      }

      // CASO 6: Cualquier otro caso no contemplado
      else {
        console.log("Error en el caso 6");

        MensajeCargaDatos.ocultar();
        MensajeTemporal.mostrarMensaje(
          "Error en la validación de datos del cliente.",
          "error",
          3500
        );
        return { success: false };
      }

      // Verificar si la operación fue exitosa
      if (!cliente) {
        MensajeCargaDatos.ocultar();
        MensajeTemporal.mostrarMensaje(
          "No se pudo procesar la información del cliente.",
          "error",
          3500
        );
        return { success: false };
      }

      // Guardar datos del cliente en localStorage para call center
      const datosParaGuardar = {
        id: cliente.id,
        nombre: cliente.nombre,
        celular: cliente.celular,
        apellido: cliente.apellido,
        email: cliente.email,
        ci: cliente.ci,
        direcciones: cliente.direcciones,
        razon_social: cliente.razon_social,
        nit: cliente.nit,
        fecha_nacimiento: cliente.fecha_nacimiento,
        permisosHutCoins: cliente.permisosHutCoins,
      };

      localStorage.setItem(
        "ph-datos-clienteFor-cc",
        JSON.stringify(datosParaGuardar)
      );

      if (!window.location.href.includes("/pages/checkout-ph")) {
        MensajeCargaDatos.ocultar();

        // Volver a la página anterior o ir al inicio
        if (document.referrer && document.referrer !== window.location.href) {
          window.location.replace(document.referrer);
        } else {
          window.location.replace("/");
        }
      }
    } catch (error) {
      MensajeCargaDatos.ocultar();
      console.error("Error en procesoManejoClienteEmpleadoCC:", error);
      MensajeTemporal.mostrarMensaje(
        error.message || "Error inesperado al procesar los datos del cliente.",
        "error",
        3500
      );
      return { success: false };
    }
  }

  // Proceso Creacion de un nuevo  usuario
  static async procesoCrearNuevoUsuario(valoresInputs) {
    try {
      // Validaciones iniciales
      const correoElectronico = valoresInputs.email;
      const numeroTelefono = valoresInputs.celular;
      const validarCorreoElectronico =
        await GestorClienteShopify.validarCorreoElectronico(correoElectronico);
      const validarNumeroTelefono =
        await GestorClienteShopify.validarNumeroTelefono(
          "+591" + numeroTelefono
        );

      // Datos base del cliente
      const datosCliente = {
        id: null,
        nombre: valoresInputs.nombre,
        apellido: valoresInputs.apellido,
        email: valoresInputs.email,
        celular: valoresInputs.celular,
        ci: valoresInputs.ci,
        nit: valoresInputs.nit,
        direcciones: valoresInputs.direcciones,
        razon_social: valoresInputs.razon_social,
        fecha_nacimiento: valoresInputs.fecha_nacimiento,
        permisosHutCoins: valoresInputs.permisosHutCoins,
      };

      let cliente = null;

      // Analisis de casos y logica para creación
      const emailExiste = validarCorreoElectronico !== null;
      const telefonoExiste = validarNumeroTelefono !== null;

      // CASO IMPORTANTE: Validar que no sea un empleado Contact Center
      if (
        emailExiste &&
        window.empleadoContactCenter.includes(validarCorreoElectronico.id)
      ) {
        MensajeCargaDatos.ocultar();
        MensajeTemporal.mostrarMensaje(
          "No sea dañino por favor! Este email está reservado para Contact Center",
          "error",
          3500
        );
        return { success: false };
      }

      if (
        telefonoExiste &&
        window.empleadoContactCenter.includes(validarNumeroTelefono.id)
      ) {
        MensajeCargaDatos.ocultar();
        MensajeTemporal.mostrarMensaje(
          "No sea dañino por favor! Este teléfono está reservado para Contact Center",
          "error",
          3500
        );
        return { success: false };
      }

      // CASO 1: Email y teléfono nuevos (no existen) - CREAR USUARIO
      if (!emailExiste && !telefonoExiste) {
        cliente = await GestorClienteShopify.crearNuevoClienteShopify(
          datosCliente
        );
      }
      // CASO 2: Email ya existe - ERROR
      else if (emailExiste && !telefonoExiste) {
        MensajeCargaDatos.ocultar();
        MensajeTemporal.mostrarMensaje(
          "El correo electrónico ya está registrado. Por favor, intenta con otro correo o inicia sesión.",
          "error",
          3500
        );
        return;
      }
      // CASO 3: Teléfono ya existe - ERROR
      else if (!emailExiste && telefonoExiste) {
        MensajeCargaDatos.ocultar();
        MensajeTemporal.mostrarMensaje(
          "El número de celular ya está registrado. Por favor, intenta con otro número o inicia sesión.",
          "error",
          3500
        );
        return;
      }
      // CASO 4: Ambos ya existen - ERROR
      else if (emailExiste && telefonoExiste) {
        MensajeCargaDatos.ocultar();
        MensajeTemporal.mostrarMensaje(
          "El correo electrónico y el número de celular ya están registrados. Por favor, inicia sesión.",
          "error",
          3500
        );
        return;
      }
      // CASO 5: Cualquier otro caso no contemplado
      else {
        MensajeCargaDatos.ocultar();
        MensajeTemporal.mostrarMensaje(
          "Error en la validación de datos. Por favor, verifica la información.",
          "error",
          3500
        );
        return;
      }

      // Verificar si la creación fue exitosa
      if (!cliente) {
        MensajeCargaDatos.ocultar();
        MensajeTemporal.mostrarMensaje(
          "No se pudo crear el usuario.",
          "error",
          3500
        );
        return;
      }

      // Verificar si hay error en la respuesta del cliente
      if (cliente.error) {
        MensajeCargaDatos.ocultar();
        MensajeTemporal.mostrarMensaje(cliente.error, "error", 3500);
        return;
      }

      // Guardar en localStorage el nuevo usuario creado
      const datosParaGuardar = {
        id: cliente.id,
        nombre: cliente.nombre,
        celular: cliente.celular,
        apellido: cliente.apellido,
        email: cliente.email,
        ci: cliente.ci,
        direcciones: cliente.direcciones,
        razon_social: cliente.razon_social,
        nit: cliente.nit,
        fecha_nacimiento: cliente.fecha_nacimiento,
        permisosHutCoins: cliente.permisosHutCoins,
      };
      localStorage.setItem(
        "ph-datos-usuario",
        JSON.stringify(datosParaGuardar)
      );

      // Mostrar mensaje de éxito
      MensajeCargaDatos.ocultar();

      // Volver a la página anterior o ir al inicio
      if (window.location.href.includes("pages/crear-cuenta")) {
        window.location.replace("/");
      } else {
        // Lógica original para otras páginas
        if (document.referrer && document.referrer !== window.location.href) {
          window.location.replace(document.referrer);
        } else {
          window.location.replace("/");
        }
      }
    } catch (error) {
      MensajeCargaDatos.ocultar();
      console.error("Error en procesoCrearNuevoUsuario:", error);
      MensajeTemporal.mostrarMensaje(
        error.message || "Error inesperado al crear el usuario.",
        "error",
        3500
      );
      return;
    }
  }

  // Proceso inicio de sesión sin OTP
  static async procesoInicioSesionSinOTP(correoElectronico, numeroTelefono) {
    try {
      // Validación inicial
      if (!correoElectronico) {
        throw new Error("Correo electrónico es requerido");
      }

      // Validar datos del usuario
      const validarCorreoElectronico =
        await GestorClienteShopify.validarCorreoElectronico(correoElectronico);
      console.log(
        "Validación de correo electrónico:",
        validarCorreoElectronico
      );
      const emailExiste = validarCorreoElectronico !== null;

      // Validar que el correo esté registrado
      if (!emailExiste) {
        MensajeCargaDatos.ocultar();
        MensajeTemporal.mostrarMensaje(
          "El correo electrónico no está registrado. Por favor, crea una cuenta o inicia sesión con otro correo.",
          "error",
          3500
        );
        return { success: false };
      }

      // El correo electrónico ya está registrado, validar número de teléfono
      if (emailExiste && numeroTelefono !== validarCorreoElectronico.celular) {
        MensajeCargaDatos.ocultar();
        MensajeTemporal.mostrarMensaje(
          "Este correo electrónico ya está registrado con otro número de celular. Por favor, inicia sesión con el número correcto o contacta al soporte.",
          "error",
          3500
        );
        return { success: false };
      }

      // Determinar tipo de usuario
      let tipoUsuario = "";
      if (
        window.empleadosCallCenter &&
        window.empleadosCallCenter.includes(validarCorreoElectronico.id)
      ) {
        tipoUsuario = "call_center";
        localStorage.setItem("ph-tipo-usuario", tipoUsuario);
      } else {
        localStorage.removeItem("ph-tipo-usuario");
      }

      // Configurar datos del cliente
      const datosCliente = {
        id: validarCorreoElectronico.id,
        nombre: validarCorreoElectronico.nombre || "",
        apellido: validarCorreoElectronico.apellido || "",
        email: validarCorreoElectronico.email || "",
        celular: validarCorreoElectronico.celular || "",
        ci: validarCorreoElectronico.ci || "",
        nit: validarCorreoElectronico.nit || "",
        razon_social: validarCorreoElectronico.razon_social || "",
        fecha_nacimiento: validarCorreoElectronico.fecha_nacimiento || "",
        permisosHutCoins: validarCorreoElectronico.permisosHut || "",
        direcciones: "",
      };

      // Configurar direcciones
      const preSeleccionEnvio = localStorage.getItem(
        "ph-pre-seleccion-envio-domicilio"
      );

      if (!preSeleccionEnvio) {
        datosCliente.direcciones = validarCorreoElectronico.direcciones || [];
      } else {
        if (tipoUsuario === "call_center") {
          datosCliente.direcciones = [JSON.parse(preSeleccionEnvio)];
        } else {
          const direccionPreSeleccionada = JSON.parse(preSeleccionEnvio);
          datosCliente.direcciones =
            GestorClienteShopify.reordenamientoDirecciones(
              validarCorreoElectronico.direcciones || [],
              direccionPreSeleccionada
            );
        }

        if (preSeleccionEnvio) {
          localStorage.removeItem("ph-pre-seleccion-envio-domicilio");
        }
      }

      // Actualizar datos del usuario
      const cliente = await GestorClienteShopify.actualizarDatosUsuarioNew(
        datosCliente
      );

      // Guardar datos en localStorage
      localStorage.setItem("ph-datos-usuario", JSON.stringify(cliente));
    } catch (error) {
      MensajeCargaDatos.ocultar();
      console.error("Error en procesoInicioSesionSinOTP:", error);
      MensajeTemporal.mostrarMensaje(
        error.message || "Error interno del servidor",
        "error",
        3500
      );
      return { success: false };
    }
  }

  // Proceso inicio de sesión con OTP
  static async procesoInicioSesionConOTP(numeroTelefono) {
    try {
      // Validación inicial
      if (!numeroTelefono) {
        throw new Error("Número de teléfono es requerido");
      }

      // Validar datos del usuario
      const numeroCompleto = "+591" + numeroTelefono;
      const validarNumeroTelefono =
        await GestorClienteShopify.validarNumeroTelefono(numeroCompleto);
      console.log("Validación de número de teléfono:", validarNumeroTelefono);

      const telefonoExiste = validarNumeroTelefono !== null;
      let datosCliente;

      if (telefonoExiste) {
        // CASO 1: Usuario existe - usar datos existentes
        // Determinar tipo de usuario
        let tipoUsuario = "";
        if (
          window.empleadosCallCenter &&
          window.empleadosCallCenter.includes(validarNumeroTelefono.id)
        ) {
          tipoUsuario = "call_center";
          localStorage.setItem("ph-tipo-usuario", tipoUsuario);
        } else {
          localStorage.removeItem("ph-tipo-usuario");
        }

        // Configurar datos del cliente existente
        datosCliente = {
          id: validarNumeroTelefono.id,
          nombre: validarNumeroTelefono.nombre || "",
          apellido: validarNumeroTelefono.apellido || "",
          email: validarNumeroTelefono.email || "",
          celular: validarNumeroTelefono.celular || "",
          ci: validarNumeroTelefono.ci || "",
          nit: validarNumeroTelefono.nit || "",
          razon_social: validarNumeroTelefono.razon_social || "",
          fecha_nacimiento: validarNumeroTelefono.fecha_nacimiento || "",
          permisosHutCoins: validarNumeroTelefono.permisosHut || "",
          direcciones: "",
        };

        // Configurar direcciones
        const preSeleccionEnvio = localStorage.getItem(
          "ph-pre-seleccion-envio-domicilio"
        );

        if (!preSeleccionEnvio) {
          datosCliente.direcciones = validarNumeroTelefono.direcciones || [];
        } else {
          if (tipoUsuario === "call_center") {
            datosCliente.direcciones = [JSON.parse(preSeleccionEnvio)];
          } else {
            const direccionPreSeleccionada = JSON.parse(preSeleccionEnvio);
            datosCliente.direcciones =
              GestorClienteShopify.reordenamientoDirecciones(
                validarNumeroTelefono.direcciones || [],
                direccionPreSeleccionada
              );
          }
          localStorage.removeItem("ph-pre-seleccion-envio-domicilio");
        }

        // Actualizar datos del usuario existente
        const cliente = await GestorClienteShopify.actualizarDatosUsuarioNew(
          datosCliente
        );
        datosCliente = cliente;
      } else {
        // CASO 2: Usuario nuevo - crear datos básicos
        localStorage.removeItem("ph-tipo-usuario");

        var codigoEnviadoCliente = GestorClienteShopify.generarCodigoTemporal();

        // Crear datos básicos para nuevo usuario
        datosCliente = {
          id: null,
          nombre: `pizzaHut${codigoEnviadoCliente}`,
          apellido: `pizzaHut${codigoEnviadoCliente}`,
          email: `pizzaHut${codigoEnviadoCliente}@gmail.com`,
          celular: numeroTelefono,
          ci: "",
          nit: "",
          razon_social: "",
          fecha_nacimiento: "",
          permisosHutCoins: false,
          direcciones: [
            {
              lat: "-17.51041339757574",
              lng: "-63.164604605594825",
              indicaciones: "Plaza Principal de Warnes, Santa Cruz.",
              alias: "Ubicación de entrega",
            },
          ],
        };

        const cliente = await GestorClienteShopify.crearNuevoClienteShopify(
          datosCliente
        );
        datosCliente = cliente;

        // Si hay dirección pre-seleccionada, agregarla
        const preSeleccionEnvio = localStorage.getItem(
          "ph-pre-seleccion-envio-domicilio"
        );
        if (preSeleccionEnvio) {
          datosCliente.direcciones = [JSON.parse(preSeleccionEnvio)];
          localStorage.removeItem("ph-pre-seleccion-envio-domicilio");
        }
      }

      // En ambos casos: guardar datos en localStorage
      localStorage.setItem("ph-datos-usuario", JSON.stringify(datosCliente));

      return { success: true };
    } catch (error) {
      MensajeCargaDatos.ocultar();
      console.error("Error en procesoInicioSesionConOTP:", error);
      MensajeTemporal.mostrarMensaje(
        error.message || "Error interno del servidor",
        "error",
        3500
      );
      return { success: false };
    }
  }

  static generarCodigoTemporal() {
    return Date.now().toString().slice(-6);
  }

  static async enviarCodigoOTP(numeroTelefono) {
    console.log("Enviando código OTP a:", numeroTelefono);
    try {
      const response = await fetch(
        `https://apicloud.farmacorp.com/apishopify/api/v1.0/sms/account/send?shopKey=ph`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization:
              `Basic MmJjODUyZmNkNWIyNzBhZmI4MzRkMDFkNWU2NjhiYzEyYjllMDgwZTo2NzczMWM4ZTU0NTdiZTU2ZWI1OTdlZDJhYWQ3NjM1ZDlkOTRjYjM3`,
          },
          body: JSON.stringify({
            numeroCelular: numeroTelefono,
          }),
        }
      );

      // Si la respuesta HTTP no es exitosa, retornar false
      if (!response.ok) {
        console.error(
          `Error en la petición: ${response.status} ${response.statusText}`
        );
        return false;
      }

      // Procesar la respuesta de la API
      const data = await response.json();

      // Extraer directamente el valor booleano de data.respuesta
      return data && data.data && data.data.respuesta === true;
    } catch (error) {
      console.error("Error al enviar código OTP:", error);
      return false; // En caso de cualquier error, retornar false
    }
  }

  static async validarCodigoOTP(codigo, numeroTelefono) {
    try {
      const response = await fetch(
        "https://apicloud.farmacorp.com/apishopify/api/v1.0/sms/account/validate",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            numeroCelular: numeroTelefono,
            pin: codigo,
          }),
        }
      );

      // Si la respuesta HTTP no es exitosa, retornar false
      if (!response.ok) {
        console.error(
          `Error en la validación: ${response.status} ${response.statusText}`
        );
        return false;
      }

      // Procesar la respuesta de la API
      const data = await response.json();

      // Extraer directamente el valor booleano de data.respuesta
      return data && data.data && data.data.respuesta === true;
    } catch (error) {
      console.error("Error al validar código OTP:", error);
      return false; // En caso de cualquier error, retornar false
    }
  }

  static reordenamientoDirecciones(listaDirecciones, direccionPreGuardada) {
    // Pre-calcular valores constantes
    const baseLat = (direccionPreGuardada.lat * Math.PI) / 180;
    const baseLng = (direccionPreGuardada.lng * Math.PI) / 180;
    const cosBaseLat = Math.cos(baseLat);
    const R = 6371000; // Radio de la Tierra en metros
    const umbralDistancia = 30; // 30 metros

    // Función optimizada para calcular distancia
    function calcularDistanciaRapida(lat, lng) {
      const dLat = ((lat - direccionPreGuardada.lat) * Math.PI) / 180;
      const dLng = ((lng - direccionPreGuardada.lng) * Math.PI) / 180;

      // Filtro rápido: si las diferencias son muy grandes, skip cálculo completo
      if (Math.abs(dLat) > 0.0003 || Math.abs(dLng) > 0.0003) return 999; // ~30m aprox

      const a =
        Math.sin(dLat * 0.5) * Math.sin(dLat * 0.5) +
        cosBaseLat *
        Math.cos((lat * Math.PI) / 180) *
        Math.sin(dLng * 0.5) *
        Math.sin(dLng * 0.5);

      return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    }

    // Buscar direcciones cercanas con early exit
    for (let i = 0; i < listaDirecciones.length; i++) {
      const direccion = listaDirecciones[i];

      if (
        calcularDistanciaRapida(direccion.lat, direccion.lng) <= umbralDistancia
      ) {
        // Encontró una cercana - moverla al final
        const nuevaLista = [...listaDirecciones];
        const [direccionCercana] = nuevaLista.splice(i, 1);
        nuevaLista.push(direccionCercana);
        return nuevaLista;
      }
    }

    // No encontró ninguna cercana - agregar la nueva al final
    return [...listaDirecciones, direccionPreGuardada];
  }
}
